<template>
    <div class="warpper">
        <div>
            <el-table :data="ideaData" border>
                <el-table-column label="序号 " type="index" width="100"></el-table-column>
                <el-table-column label="时间" prop="addtime" width="150"></el-table-column>
                <el-table-column label="手机号" prop="phone" width="150"></el-table-column>
                <el-table-column label="反馈内容" prop="title"></el-table-column>
                <el-table-column label="图片" width="250">
                    <template slot-scope="scope">
                        <el-image
                            :src="item"
                            v-for="(item, index) of scope.row.imgs"
                            :preview-src-list="scope.row.imgs"
                            :key="index"
                            style="height:40px;margin-right:10px"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline" style="font-size:30px"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="deleteIt(scope.row.id)">{{ $t('common.delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" style="text-align: center">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :current-page="query.page"
                    :page-size="query.page_size"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ideaIndex, ideaDel } from '@/request/api.js';
export default {
    name: 'vuename',
    data() {
        return {
            query: {
                page: 1,
                page_size: 10
            },
            pageTotal: 10,
            ideaData: []
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            ideaIndex({ ...this.query }).then(res => {
                this.ideaData = res.data.data;
                this.pageTotal = res.data.count;
            });
        },
        deleteIt(id) {
            this.$confirm('确定要删除该反馈嘛？', '提示', {
                type: 'warning'
            }).then(() => {
                ideaDel({ id }).then(res => {
                    if (res.code == 2000) {
                        this.$message.success(res.data);
                    } else {
                        this.$message.error(res.data);
                    }
                    this.getData();
                });
            });
        },
        //分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.query.page = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.query.page_size = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
.warpper {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
}
</style>
